<template>
  <header v-if="commitment.$ready" class="task-list-header bg-image clearfix">
    <!-- <img v-if="commitment.picture" :src="commitment.picture" /> -->
    <div style="display: flex; flex-direction: column; justify-content: center">
      <div style="display: flex; justify-content: space-between; align-items: flex-start">
        <div class="headline" :ref="'headline-' + commitmentId">
          <inline-editable-text
            style="width: auto"
            @change="onSetCommitmentName($event)"
            :inline="true"
            :class="[ 'commitment-text', 'clearfix', 'type-'+(commitment.type || 'no').toLowerCase() ]"
            :value="commitment.meta.name"
            :id="commitmentId"
            :resetOnCancel="false"
          >
            <h4 style="display: inline-block" slot-scope="props">{{props.text}}</h4>
          </inline-editable-text>
        </div>
        <div style="display: flex; align-items: center;">
          <!-- v-tooltip="{ content: 'Click and drag left or right to move this lane' }" /> -->
          <div @mouseover="onMouseoverEllipsisButton">
            <template v-if="ellipsisButtonActive">
              <ellipsis-button
                v-if="commitment.access.allow_to_edit_commitments"
                class="pl-2"
                heading="List Actions"
                :show-options="['edit', 'slot', 'archive', 'delete']"
                @edit="onOpenCommitmentModal(commitmentId)"
                @archive="onRemoveCommitment(false)"
                @delete="onRemoveCommitment(true)"
              >
                <el-button class="btn-block ml-0" size="mini" @click.prevent="onMoveCommitment()">
                  <font-awesome-icon icon="truck" class="taskicon"/>Move to another goal
                </el-button>

                <el-button class="btn-block ml-0" size="mini" @click.prevent="onExportCommitment()">
                  <font-awesome-icon icon="file-download" class="taskicon"/>Export tasklist
                </el-button>

                <!--
            <el-button class="btn-block ml-0" size="mini" @click="onHandleMenuAction('info')" plain>
              <font-awesome-icon icon="info-circle" class="laneicon" />
              Menu item
            </el-button>
                -->
              </ellipsis-button>
            </template>
            <template v-else>
              <div class="ellipsis-button pl-2">
                <el-button class="ellipsis-button__button">
                  <font-awesome-icon size="sm" :icon="['fas', 'ellipsis-v']" color="#687a8c"/>
                </el-button>
              </div>
            </template>
          </div>
          <!--<font-awesome-icon class="drag-handle" :icon="['fas', 'arrows-alt-h']" color="black"/>-->
        </div>
      </div>

      <!-- <span class="m-0 p-1">{{isUnsortedLane ? 'UNASSIGNED' : commitment.name}}</span> -->
      <div class="pt-1">
        <!--
        <span v-show="savingDrag">...</span>
        <el-button class="mt-3" size="sm" variant="outline-danger" block :disabled="deleting" @click="onClickDeleteLane(commitmentId, true)">DELETE</el-button>
        -->

        <!-- TODO: merge with UserAvatar.vue and UserMiniAvatar.vue -->
        <div
          v-if="commitment.type === 'TASKLIST' || commitment.type === 'TIME_BASED_TASKLIST' || commitment.type === 'SEQUENCE'"
          class="task-list-header__info text-center pt-1">
          <div
            style="display: flex; flex-direction: column; justify-content: flex-start;"
            v-if="current_user_membership.$ready">
            <!-- BUG -->
            <div @mouseover="onMouseoverContactImage">
              <template v-if="contactImageMouseoverActive">
                <el-popover placement="bottom" :width="goal_meta.isTeamgoal ? 360 : 100" :open-delay="100" trigger="hover">
                  <!-- TODO move to component? -->

                  <!-- <pre class="mini-pre">{{ commitment.access }}</pre> -->
                  <template v-if="goal_meta.isTeamgoal">

                    <div class="ellipsis-button__heading"></div>
                    <collapse-group title="This commitment is assigend to:" :init-collapse="false" class="mb-2">
                      <div>
                        {{assigned_user_contact.displayName}}
                        ( You are:
                        <span
                          v-if="current_user_membership.$state.isOwner"
                          style="font-weight: bold">
                          owner
                        </span>
                        <span v-else-if="current_user_membership.$state.isAdmin">admin</span>
                        <span v-else>member</span>
                        )
                      </div>
                    </collapse-group>

                    <collapse-group title="Your access rights are:" :init-collapse="true" class="mb-2">
                      <!-- <div class="ellipsis-button__heading pt-4"></div> -->
                      <ul class="list-group">
                        <li
                          :class="[
                            'p-1',
                            'list-group-item',
                            has_access ? 'list-group-item-success' : 'list-group-item-danger'
                          ]"
                          v-for="(has_access, idx) in commitment.access"
                          :key="idx">
                          <template v-if="has_access">{{accessKeyNameMap[idx]}}</template>
                          <template v-else>
                            <!-- TODO: i18n -->
                            {{accessKeyNameMap[idx].replace('allowed','not allowed')}}
                          </template>
                        </li>
                      </ul>
                    </collapse-group>
                  </template>
                  <template v-else>
                    <span class="">This is you :-)</span>
                  </template>

                  <div
                    slot="reference"
                    v-if="assigned_user_id"
                    @click="onGoToUserPage(assigned_user_id)"
                    class="clickable">
                    <!-- <el-tooltip class="item" effect="dark" placement="right":content="">
                    </el-tooltip>-->
                    <img
                      :class="{
                      'user-image': true,
                      'pulse-ring': active_task_timer
                      }"
                      :src="assigned_user_contact.profilePic|defaultUserPic"
                      width="48"
                      height="48">
                  </div>
                  <div v-else>
                    <img class="user-image" :src="''|defaultUserPic" width="64" height="64">
                    <span class="m-2 text-small">Unassigned Commitment</span>
                  </div>
                  <!--
              <font-awesome-icon
                slot="reference"
                size="sm"
                :icon="['fas', 'info-circle']"
                color="#687a8c"
                style="display:inline-block; margin-left: 5px"
                class="inline-icon" />
                  -->
                </el-popover>
              </template>
              <template v-else>
                <div
                  slot="reference"
                  v-if="assigned_user_id"
                  @click="onGoToUserPage(assigned_user_id)"
                  class="clickable">
                  <!-- <el-tooltip class="item" effect="dark" placement="right":content="">
                  </el-tooltip>-->
                  <img
                    :class="{
                      'user-image': true,
                      'pulse-ring': active_task_timer
                      }"
                    :src="assigned_user_contact.profilePic|defaultUserPic"
                    width="48"
                    height="48"
                  >
                </div>
                <div v-else>
                  <img class="user-image" :src="''|defaultUserPic" width="64" height="64">
                  <span class="m-2 text-small">Unassigned Commitment</span>
                </div>
              </template>
            </div>

            <InlineCommitmentStatus class="pt-4" :commitment-meta="commitment.meta" />

            <!--<template v-if="commitment.meta.active">
                <font-awesome-icon
                  icon="pause"
                  @click="onActivateCommitment(false)"
                  class="inline-icon"
                  v-tooltip="'Deactivate commitment. This will exclude this<br /> commitment from automatic planning.'" />
              </template>
              <template v-else>
                <font-awesome-icon
                  icon="play"
                  @click="onActivateCommitment(true)"
                  class="inline-icon"
                  v-tooltip="'Reactive commitment and include into automatic planning.'" />
            </template>-->

            <div
              v-if="commitment.type === 'TIME_BASED_TASKLIST'"
              v-tooltip="{ content:
                  'Start date: ' + this.$filters.shortDate(commitment.startDate) | '-' + '<br />'
                + 'End date: ' + this.$filters.shortDate(commitment.endDate) | '-'
              }">
              <duration-quick-settings
                v-model="committed_time"
                :quickDurationSettings="{
                  '0 h': 0 * 60,
                  '1 h': 60 * 60,
                  '2 h': 120 * 60,
                  '3 h': 180 * 60,
                  '4 h': 240 * 60,
                  '5 h': 300 * 60,
                  '10 h': 600 * 60,
                  '15 h': 900 * 60,
                  '20 h': 1200 * 60,
                  '30 h': 1800 * 60,
                  '40 h': 2400 * 60,
                  '50 h': 3000 * 60,
                  '75 h': 4500 * 60,
                  '100 h': 6000 * 60,
                  '500 h': 30000 * 60,
                  '1.000 h': 60000 * 60,
                  '5.000 h': 300000 * 60,
                  '10.000 h': 600000 * 60
                }"
              ></duration-quick-settings>
            </div>
            <div v-else-if="commitment.type === 'TASKLIST'">
              Finish all tasks
              <!-- TODO -->
            </div>
          </div>
        </div>

        <div v-if="commitment.type === 'BACKLOG'" class="task-list-header__info text-center">
          <div>
            <!-- (Backlog) -->
            <font-awesome-icon icon="tasks" size="2x" color="#aaa"/>
          </div>
        </div>

        <div v-if="commitment.type === 'HABIT'" class="task-list-header__info text-center">
          <img class="w-50 m-6" src="@/assets/flaticons/meditation.svg">
        </div>

        <div v-if="commitment.type === 'AMOUNT'" class="task-list-header__info text-center">
          <img class="w-50 m-6" src="@/assets/flaticons/save.svg">
        </div>

        <div
          class="commitment-picture"
          :style="{
            'background-image': 'url(' + commitment.picture + ')'
          }"
        ></div>
      </div>
    </div>
    <div>
      <div v-if="commitment.meta.deleted" class="lane-deleted-info">
        This committment has been archived.
        <br>
        <el-button @click="onUnarchive" class="m-4" size="mini">Restore</el-button>
      </div>
      <div v-if="commitment.templateId">This committment comes from a challenge</div>
      <template
        v-if="commitment.type === 'TASKLIST' || commitment.type === 'TIME_BASED_TASKLIST' || commitment.type === 'SEQUENCE'">
        <div
          v-if="commitment.type /*TODO*/"
          class="clearfix"
          style="margin: 0.5em; display: flex; flex-direction: column; justify-content: center;">
          <div v-if="commitment.type === 'TIME_BASED_TASKLIST'">

            <!-- <InlineCommitmentProgress :commitmentMeta="commitment" :goalId="goalId"/> -->

            <!-- show planning progress, instead of commitment progress -->
            <el-progress
              :percentage="Math.min(percentage_planned, 100)"
              :stroke-width="10"
              :status="percentage_planned >= 100 ? 'warning' : null" />

          </div>
          <div
            v-if="commitment.startDate && commitmentFinishDate > 0"
            style="margin: 0.5em; display: flex; justify-content: center; ">
            Finish:
            <font-awesome-icon
              :icon="['fas', 'flag-checkered']"
              style="margin-left: 0.5em; margin-right: 0.3em"
              v-tooltip="{ content: 'Estimated completion date'}"
            />
            {{ commitmentFinishDate && commitmentFinishDate > 0
            ? this.$filters.shortDateTime(commitmentFinishDate * 1000)
            : '' }}
            <!-- {{ '> ' + optimizer_planning_horizon + ' days (Go Pro)' }} -->
          </div>
        </div>
        <div v-else>
          No access.
          <a href="#" @click.prevent="onRequestPermission">Request pemission</a>.
        </div>
      </template>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
// import InlineCommitmentProgress from "@/components/GoalPage/Elements/InlineCommitmentProgress";
import InlineCommitmentStatus from "@/components/GoalPage/Elements/InlineCommitmentStatus";
import GoalPromptMixin from "@/components/Mixins/Prompts/GoalPrompt";
import util from "@/util";
import moment from "@/moment-gp";
import DurationQuickSettings from "@/components/Elements/DurationQuickSettings";

// TODO: Move to i18n
const accessKeyNameMap = {
  allow_to_edit_commitments: "You're allowed to edit commitments",
  allow_to_edit_tasks: "You're allowed to edit tasks details",
  allow_to_see_tasks_details: "You're allowed to edit tasks",
  allow_to_see_commitment: "You're allowed to see commitment",
  allow_to_see_enddates: "You're allowed to see enddates",
  allow_to_see_recorded_sessions: "You're allowed to see recorded sessions",
  allow_to_see_task_sessions: "You're allowed to see task sessions",
  allow_to_see_tasks: "You're allowed to see tasks",
  allow_to_edit_tasks_details: "You're allowed to see tasks details",
  allow_to_see_daily_commitments: "You're allowed to see daily commitment settings",
};

export default {
  mixins: [GoalPromptMixin],
  props: {
    goalId: {
      required: true,
    },
    commitmentId: {
      required: true,
    },
    commitmentFinishDate: {
      type: Number,
      default: 0,
    },
    activeTask: {
      type: Object,
    },
    durationPlanned: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      deleting: false,
      savingDrag: false,
      accessKeyNameMap,
      ellipsisButtonActive: false,
      contactImageMouseoverActive: false,
    };
  },
  watch: {
    assigned_user_id: {
      handler(user_id) {
        /* We have to wait for commitment to load before we get a valid
         * assigend_user id! */
        if (user_id) {
          this.$api.contact_add_if_not_cached(user_id);
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("contact", ["get_contact_by_id"]),

    ...mapGetters("optimizer", ["optimizer_finish_dates_commitments", "optimizer_planning_horizon"]),

    commitment() {
      return this.$models.commitment.with({ goalId: this.goalId }).getNodeFull(this.commitmentId);
    },

    goal_meta() {
      return this.$models.goalMeta.getNode( this.goalId );
    },

    active_task_timer() {
      if (this.activeTask) {
        return this.activeTask.goalId === this.goalId;
      } else {
        return false;
      }
    },

    committed_time: {
      get() {
        if (this.commitment.$ready) {
          return this.commitment.committedTime;
        } else {
          return null;
        }
      },
      set(value) {
        this.commitment.update({ committedTime: value });
      },
    },

    percentage_planned() {
      return Math.round(( this.durationPlanned / this.committed_time ) * 100);
    },

    /*
    planning_strategy: {
      get() {
        return 'AUTOMATIC'
      },
      set(value) {
        if ( value === 'AUTOMATIC' ) {
          this.commitment.update({ committedTimePerDay: this.commitment.committedTimeDaily })
        }
        if ( value === 'MANUALLY' ) {
          this.commitment.update({ committedTimePerDay: null, committedTimeDaily: this.commitment.committedTimeDaily })
        }
      }
    },
    */

    // commitment() {
    //   TODO: Careful, this information is only available to some users!!
    //   TODO: Rather sync entire list one level highter .subscribeList() and use .getNode here
    //   return this.$models.commitment.with({ goalId: this.goalId }).getNode( this.commitmentId );
    //   return this.$models.commitment.with({ goalId: this.goalId }).subscribeNode( this.commitmentId );
    // },
    // commitment.meta() {
    //   return this.$models.commitmentMeta.with({ goalId: this.goalId }).getNode( this.commitmentId );
    // },

    assigned_user_id() {
      return this.commitment.meta.assignedUserId;
    },

    assigned_user_membership() {
      if (this.assigned_user_id) {
        let assigned_user_membership = this.$models.goalMember
          .with({ goalId: this.goalId })
          .getNode(this.assigned_user_id);
        return assigned_user_membership;
      }
      return {};
    },

    assigned_user_contact() {
      if (this.assigned_user_id) {
        let contact = this.$models.userContact.get_contact_by_id(this.assigned_user_id);
        return contact;
        /* return contact !== null ? contact : {
          displayName: 'Loading...',
          profilePic: null
        }; */
      }
      return {
        displayName: "Unassigned",
        profilePic: null,
      };
    },

    isUnsortedLane() {
      // return this.lane.$id === '_UNASSIGNED';
      return false;
    },

    /* TODO: Move to model getter */
    current_user_membership() {
      let current_user_id = this.$models.user.defaultUserId;
      // todo: let current_user_id = this.$models.userdata.currentUserId
      let current_user_membership = this.$models.goalMember.with({ goalId: this.goalId }).getNode(current_user_id);
      return current_user_membership;
    },
  },
  methods: {
    onMouseoverEllipsisButton() {
      this.ellipsisButtonActive = true;
    },
    onMouseoverContactImage() {
      this.contactImageMouseoverActive = true;
    },

    onSetCommitmentName(new_commitment_name) {
      console.log("Updating commitment title to ", this.commitmentId, new_commitment_name);

      this.$models.commitmentMeta
        .with({ goalId: this.goalId })
        .update(this.commitmentId, { name: new_commitment_name });

      // this.$api.commitment_update({
      //   commitment_id: this.commitmentId,
      //   goal_id: this.goalId,
      //   data: { name: new_commitment_name }
      // })
    },

    onMoveCommitment() {
      this.$goal_prompt({
        title: "Select a new goal for this tasklist",
        filterGoalId: this.goalId,
      }).then(({ targetGoalId, done }) => {
        this.$api
          .commitment_move_to_goal({
            src_goal_id: this.goalId,
            dst_goal_id: targetGoalId,
            commitment_id: this.commitmentId,
          })
          .then(done);
      });
    },

    onExportCommitment() {
      this.$api
        .commitment_export_to_json({
          goal_id: this.goalId,
          commitment_id: this.commitmentId,
          member_id: this.assigned_user_id,
        })
        .then(json => {
          window.debub_json_import = JSON.parse(json); // TODO !!!!
          let filename = this.commitment.meta.name + " (" + moment().format("YYYY-MM-DD_HH-MM") + ")" + ".json";
          util.saveJSON(json, filename);
        });
    },

    onRemoveCommitment(hard_delete) {
      // TODO Mixin
      if (hard_delete) {
        this.$confirm("This will permanently delete the lane including all tasks. Continue?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {
            this.$api
              .commitment_delete(
                {
                  goal_id: this.goalId,
                  commitment_id: this.commitmentId,
                  is_backlog: this.commitment.type === "BACKLOG",
                },
                "hard"
              )
              .then(() => {
                this.$notify({ type: "success", message: "Delete completed" });
              });
          })
          .catch(() => {});
      } else {
        this.$api.commitment_delete(
          {
            goal_id: this.goalId,
            commitment_id: this.commitmentId,
            is_backlog: this.commitment.type === "BACKLOG",
          },
          "soft"
        );
      }
    },

    onOpenCommitmentModal() {
      this.$root.showUpdateModal("effort", {
        memberId: this.assigned_user_id,
        goalId: this.goalId,
        commitmentId: this.commitmentId,
      });
    },

    onRequestPermission() {
      console.log("onRequestPermission - TODO");
    },

    onActivateCommitment(state) {
      console.log("onActivateCommitment", state);
      this.$models.commitmentMeta.with({ goalId: this.goalId }).update(this.commitmentId, {
        active: state,
      });
    },

    onUnarchive() {
      this.commitment.meta.update({ deleted: false });
    },
    onGoToUserPage(assigned_user_id) {
      this.$router.push("/user/" + assigned_user_id);
    },
  },
  components: {
    // InlineCommitmentProgress,
    InlineCommitmentStatus,
    DurationQuickSettings,
  },
};
</script>

<style>
.task-list-header:hover .drag-handle {
  display: block;
}
.task-list-header:not(:hover) .drag-handle {
  display: none;
}
.task-list-header {
  /* position: relative; */
  padding-top: 0.5em;
  padding-left: 0.5em;
  padding-right: 0.5em;
  height: auto; /* TODO */
  /* min-height: 228px; */
  min-height: 200px;
  overflow: hidden;
  word-break: break-word;
}
.task-list-header .drag-handle {
  cursor: grab;
}
.task-list-header .headline {
  width: auto;
}
.task-list-header .bg-image {
  display: block;
  background: #9a9a9a;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 116px;
  width: 170px;
  float: right;
  color: white;
  padding: 8px;
}
.task-list-header .commitment-picture {
  display: block;
  background: #9a9a9a;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 116px;
  width: 170px;
  float: right;
  color: white;
  padding: 8px;
  border-radius: 5px;
}
.task-list-header .commitment-text {
  cursor: text;
  width: 80%;
  /* margin: 0;
  margin-right: 55px;
  padding: 1px 5px; */
}
.task-list-header .commitment-text:hover {
  /*
  border: 1px dashed gray;
  margin: -1px;
  */
  /* padding: 0 4px; */
}
.task-list-header .user-image {
  border-radius: 100%;
  border: 2px solid #000000;
}
.task-list-header .laneicon {
  cursor: pointer;
  margin: 0 0 0 10px;
}
.commitment-text.type-sequence {
  color: var(--indigo);
}
.task-list-header__info {
  width: 100px;
  float: left;
  height: 120px;
}

.task-list-header .el-progress-bar {
  padding-right: 37px;
  margin-right: -45px;
}

.pulse-ring {
  content: "";
  width: 48px;
  height: 48px;
  border: 10px solid #f00;
  border-radius: 50%;
  top: 18px;
  left: 18px;
  animation: pulsate infinite 2s;
}

@-webkit-keyframes pulsate {
  0% {
    border: 2px solid #69b42d;
  }
  50% {
    border: 2px solid #ffffff;
  }
  100% {
    border: 2px solid #69b42d;
  }
}
</style>
